
// import _get from 'lodash.get';
import { mutations, actions } from '@/store/types';
import { DeviceInfo } from '@/types/device-info';
import { SetDeviceMutationType } from '@/types/store/mutations';
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import DrawerAccount from './DrawerAccount.vue';
import { helpAndSupportURL } from '@/constants/constants';
import { deviceMenuOptions } from '@/constants/sideBarDeviceOptions';
import api from '@/modules/api';
import { UserInfo } from '@/types/user-info';
import { getErrorMessage } from '@/utils/common';
import { userRoles } from '@/constants/userRoles';
import LoadableMixin from '@/mixins/LoadableMixin';
import { LoadGroupsActionType } from '@/types/store/actions';
import GroupOptionsMenu from '@/components/devices/menus/GroupOptionsMenu.vue';

@Component({
    components: {
        DrawerAccount,
        GroupOptionsMenu
    },
})
export default class SideMenuTemplateRendrer extends Mixins<LoadableMixin>(LoadableMixin) {
    protected helpAndSupportURL = helpAndSupportURL;
    protected deviceMenuOptions = deviceMenuOptions;
    isUserK9 = false;
    isUserShareAccount = false;

    @Prop({ required: true })
    permanent!: boolean;

    @Prop({ required: true })
    isDrawer!: boolean;

    @State('devices')
    devices!: DeviceInfo[];

    @State('groups')
    groups!: any[];

    @State('allDevices')
    allDevices!: DeviceInfo[];

    @State('device')
    device!: DeviceInfo;

    @State('selectedDeviceType')
    selectedDeviceType!: string;

    @State('user')
    user!: UserInfo;

    @Action(actions.LOAD_GROUPS)
    loadGroups!: LoadGroupsActionType;

    @Prop({ required: true })
    toggleDrawer!: (val: boolean) => void;

    @Mutation(mutations.SET_CURRENT_DEVICE)
    setCurrentDevice!: SetDeviceMutationType;

    async handleDeviceTypeClick(deviceTypeValue: string) {
        this.toggleDrawer(false);
        this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: deviceTypeValue });
        this.$store.commit(mutations.LOADING, { loading: true });
        this.$store.commit(mutations.SET_SEARCH_NAME, { searchName: '' });
        try {
            //filter devices by type
            const filteredDevices = await api.loadDevices(
                this.user._id as string,
                { page: 0, perPage: 999 },
                deviceTypeValue,
                '',
            );
            this.$store.commit(mutations.SET_DEVICES, { devices: filteredDevices });

            // set selected device
            const index = filteredDevices.findIndex((currentdevice) => currentdevice._id === this.device?._id);
            if (filteredDevices.length == 0) {
                this.setCurrentDevice({ device: null });
                this.handleNavigate('');
            } else if (this.device === null || index === -1) {
                this.setCurrentDevice({ device: filteredDevices[0] });
                this.handleNavigate(filteredDevices[0].deviceUUID as string);
            } else {
                this.handleNavigate(this.device?.deviceUUID as string);
            }
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }

    handleGroupTypeClick(group: any) {
        this.$store.commit(mutations.LOADING, { loading: true });
        this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: group.name });
        this.toggleDrawer(false);
        this.$store.commit(mutations.SET_SEARCH_NAME, { searchName: '' });
        if (this.$route.path != `/group/devices${group._id ? `/${group._id}` : ''}`) {
            this.$router.push({
                name: 'group-device',
                params: { groupId: group._id }
            });
        }
        this.$store.commit(mutations.LOADING, { loading: false });
    }
    handleCreateNewTypeClick(name: string, routeName: string) {
        this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: name });
        this.$router.push({
            name: routeName,
        });
    }

    // handleDeviceClick(device: DeviceInfo) {
    //     this.toggleDrawer(false);
    //     this.setCurrentDevice({ device });
    //     this.$router
    //         .push({ name: 'device-settings', params: { deviceUUID: device.deviceUUID as string } })
    //         .catch((error) => error);
    // }

    mounted() {
        if (this.user.roles.includes('k9')) {
            this.isUserK9 = true;
        }
        if (this.user.roles.includes(userRoles.Enterprise) || this.user.roles.includes(userRoles.Admin) || this.user.roles.includes(userRoles.SuperAdmin) || this.user.roles.includes(userRoles.EnterpriseNoApi)) {
            this.loadGroups()
            this.isUserShareAccount = true;
        }
    }

    handleMenuItemClick() {
        this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: '' });
        this.toggleDrawer(false);
        this.$store.commit(mutations.SET_SEARCH_NAME, { searchName: '' });
    }

    isActive(deviceTypeValue: string) {
        return deviceTypeValue === this.selectedDeviceType;
    }

    // isActive(device: DeviceInfo) {
    //     return device.deviceUUID === _get(this.$route, 'params.deviceUUID');
    // }

    isMoreActive(routeName: string[]) {
        let current: string = this.$route.name ? this.$route.name : '';
        return routeName.indexOf(current) > -1;
    }

    get mini() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    ResetDevices() {
        this.setCurrentDevice({ device: null });
        this.toggleDrawer(false);
    }

    onLogoClick() {
        this.toggleDrawer(false);
        this.handleDeviceTypeClick('all');
    }

    handleAirBoltsClick() {
        if (this.device) {
            this.handleNavigate(this.device.deviceUUID as string);
        } else if (this.devices.length > 0) {
            this.handleNavigate(this.devices[0].deviceUUID as string);
        } else {
            this.handleNavigate('');
        }
    }

    handleNavigate(deviceUUID: string) {
        if (this.$route.path != `/device${deviceUUID ? `/${deviceUUID}` : ''}`) {
            this.$router.push({
                name: 'device-overview',
                params: deviceUUID ? { deviceUUID } : {},
            });
        }
    }
}
